import { useEffect, useState, useMemo } from "react";
import { api } from "../lib/api";

// PUBLIC_MODE=true (production/preview) hides commerce and shows the splash + ribbon.
// When the owner_preview cookie is set (verified via /owner-preview), we bypass
// public mode and show the full site — even if PUBLIC_MODE is true.
export function usePublicMode() {
  const envPublic = String(process.env.REACT_APP_PUBLIC_MODE).toLowerCase() === "true";
  const [isOwner, setIsOwner] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/owner-preview/status");
        if (!cancelled) setIsOwner(Boolean(data?.is_owner));
      } catch {
        if (!cancelled) setIsOwner(false);
      } finally {
        if (!cancelled) setChecked(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return useMemo(
    () => ({ publicMode: envPublic && !isOwner, isOwner, checked, envPublic }),
    [envPublic, isOwner, checked],
  );
}
